import { lazy } from 'react';

const componentCustom = lazy(() => import('./components/componentCustom.js'));

const customComponents = new Map();

customComponents.set('componentCustom', componentCustom);

export default customComponents;
